<div class="grid grid--va-middle">
  <div class="grid__box grid__box--size-6 grid__box--pull-left">
    <div class="grid grid--gap-24">
      <div class="grid__box grid__box--size-min">
        <span class="title title--s">Показать</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <a
          class="link"
          [ngClass]="{
            'link--dotted-gray-dark': filter.notificationsShowTypeSelected !== 'status',
            'link--bold link--no-underline': filter.notificationsShowTypeSelected === 'status'
          }"
          (click)="filter.onChangeNotificationsFilterType('status')"
          >Только непрочитанные</a
        >
      </div>
      <div class="grid__box grid__box--size-min">
        <a
          class="link link--dotted-gray-dark"
          [ngClass]="{
            'link--dotted-gray-dark': filter.notificationsShowTypeSelected !== 'priority',
            'link--bold link--no-underline': filter.notificationsShowTypeSelected === 'priority'
          }"
          (click)="filter.onChangeNotificationsFilterType('priority')"
          >Только важные</a
        >
      </div>
      <div class="grid__box grid__box--size-min">
        <a
          class="link link--dotted-gray-dark"
          [ngClass]="{
            'link--dotted-gray-dark': filter.notificationsShowTypeSelected !== 'all',
            'link--bold link--no-underline': filter.notificationsShowTypeSelected === 'all'
          }"
          (click)="filter.onChangeNotificationsFilterType('all')"
          >Все</a
        >
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="!isAllNotificationsRead">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link link--dotted-gray-dark" *ngIf="!isAllNotificationsRead" (click)="filter.onChangeNotificationsStatuses('check')">Пометить все прочитанным</a>
        <!--<a class="link link&#45;&#45;dotted-gray-dark" *ngIf="isAllNotificationsRead"-->
        <!--(click)="filter.onChangeNotificationsStatuses('uncheck')">Пометить все непрочитанным</a>-->
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-6 grid__box--pull-left">
    <div class="grid grid--va-middle grid--gap-32 grid--justify-content-flex-end">
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--gap-4">
          <div class="grid__box grid__box--size-min">
            <app-icon [glyph]="'update'" [color]="'gray-dark'" [size]="'16'" [class]="'icon--va-middle'"></app-icon>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link link--dotted-gray-dark" (click)="filter.onUpdateWidget()">Обновить список</a>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-8">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <span class="title title--s">Тип</span>
          </div>
          <div class="grid__box grid__box--size-6">
            <app-select
              [items]="filter.notificationsStatues"
              (callback)="onChangeNotificationType($event)"
              [textKey]="'name'"
              [defaultText]="'Выберите тип'"
              [initBy]="filter.notificationStatusSelected"
              [name]="'ticketsTypeName'"
            ></app-select>
          </div>
          <div class="grid__box grid__box--size-min">
            <button class="button" type="button" (click)="filter.onApplyFilter()">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min" (click)="filter.onResetFilter()">
            <button class="ctrl link link--dotted-blue-dark">Сбросить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
